import { Routes } from '@angular/router';
import { VerifyComponent } from './containers/verify/verify.component';
import { PAGES_PATH } from './shared/constants';
import { AuthGuard, LoginSuccess } from './shared/helpers/auth-guard';
import { PermissionGuard } from './shared/helpers/permission-guard';
import { TranslationGuard } from './shared/helpers/i18n-guard/translation.guard';
import { I18n } from '@app/i18n/strings-keys';

export * from './routes';

const APP_GENERIC_GUARD = [TranslationGuard];

// This file is used to define the routes for the application.
// All valid business-related routes under this project should be defined here.
export const MODULE_ROUTES: Routes = [
  { path: '', redirectTo: PAGES_PATH.Verify, pathMatch: 'full' },
  {
    path: PAGES_PATH.Verify,
    component: VerifyComponent,
  },
  {
    path: PAGES_PATH.SignIn,
    loadChildren: () =>
      import('./containers/sign-in/sign-in.module').then(
        (module) => module.SignInModule,
      ),
    canActivate: [AuthGuard, ...APP_GENERIC_GUARD],
  },
  {
    path: PAGES_PATH.SelectEvent,
    loadChildren: () =>
      import('./containers/select-event/select-event.module').then(
        (module) => module.SelectEventModule,
      ),
    canActivate: [LoginSuccess, ...APP_GENERIC_GUARD],
  },
  {
    path: PAGES_PATH.ItemCountDetail,
    loadChildren: () =>
      import('./containers/item-count/item-count.module').then(
        (module) => module.ItemCountModule,
      ),
    canActivate: [LoginSuccess, ...APP_GENERIC_GUARD],
  },
  {
    path: PAGES_PATH.RequestTransferList,
    loadChildren: () =>
      import('./containers/request-transfer/request-transfer.module').then(
        (module) => module.RequestTransferModule,
      ),
    canActivate: [LoginSuccess, PermissionGuard, ...APP_GENERIC_GUARD],
    data: {
      requiredPermissions: [
        'VenuesInventory.TransferRequest.Manage',
        'VenuesInventory.MultiStandTransferRequest.Manage',
      ],
      errorMessage: I18n.CommonErrors.NoPermittedForTransfer,
      permissionOR: true,
    },
  },
  {
    path: PAGES_PATH.Success,
    loadChildren: () =>
      import('./containers/success/success.module').then(
        (m) => m.SuccessModule,
      ),
    canActivate: [LoginSuccess, ...APP_GENERIC_GUARD],
  },
];
